module.exports = __webpack_public_path__ + "img/lv_failure_6.05589369.png";